'use client'

import { ChevronDownIcon } from '@repo/studio-design-system-ui-icons/arrows/chevron-down'
import { CheckIcon } from '@repo/studio-design-system-ui-icons/general/check'
import * as React from 'react'
import * as Select from 'primitives/select'
import type { SelectItemProps } from 'primitives/select'
import { tw } from 'utils/classnames'

const sortOptions = [{ label: 'Relevance', value: 'relevance' }]

export function SortOption() {
  const selected = sortOptions[0].value
  return (
    <div className="ml-1 flex sm:ml-3">
      <Select.Root value={selected}>
        <Select.Trigger className="rounded-2 flex h-9 items-center justify-center border border-gray-800 px-4 text-xs font-medium text-gray-100">
          <Select.Value placeholder="Select order" />{' '}
          <Select.Icon>
            <ChevronDownIcon className="ml-2 size-4 text-gray-500" />
          </Select.Icon>
        </Select.Trigger>
        <Select.Content
          className="rounded-4 bg-gray-1000 z-50 border border-gray-800 p-[10px]"
          position="popper"
          align="end"
          sideOffset={4}
        >
          <Select.Viewport className="flex flex-col gap-1 p-[2px]">
            {sortOptions.map(({ value, label }) => (
              <SelectItem
                key={value}
                value={value}
                isSelected={selected === value}
                className="rounded-2 flex h-[40px] cursor-pointer items-center justify-start px-3 py-4 font-medium hover:bg-gray-800"
              >
                {label}
              </SelectItem>
            ))}
          </Select.Viewport>
        </Select.Content>
      </Select.Root>
    </div>
  )
}

const SelectItem = ({
  ref: forwardedRef,
  children,
  className,
  isSelected,
  ...props
}: SelectItemProps & {
  isSelected: boolean
  className?: string
  ref?: React.RefObject<HTMLDivElement | null>
}) => {
  return (
    <Select.Item
      className={tw(
        'flex items-center text-gray-400 hover:bg-gray-800 hover:text-gray-400',
        isSelected && 'text-service-white-white bg-violet-500',
        className,
      )}
      {...props}
      ref={forwardedRef}
    >
      <Select.ItemText>{children}</Select.ItemText>
      <Select.ItemIndicator className={tw('ml-2 flex size-4 flex-shrink-0 items-center')}>
        <CheckIcon />
      </Select.ItemIndicator>
    </Select.Item>
  )
}

SelectItem.displayName = 'SelectItem'
